module.exports = __webpack_public_path__ + "static/media/abstract2.5eac1357.svg";